import { render, staticRenderFns } from "./NotificationTable.vue?vue&type=template&id=8a283fa0&scoped=true&"
import script from "./NotificationTable.vue?vue&type=script&lang=js&"
export * from "./NotificationTable.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTable.vue?vue&type=style&index=0&id=8a283fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a283fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a283fa0')) {
      api.createRecord('8a283fa0', component.options)
    } else {
      api.reload('8a283fa0', component.options)
    }
    module.hot.accept("./NotificationTable.vue?vue&type=template&id=8a283fa0&scoped=true&", function () {
      api.rerender('8a283fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/notifications/components/NotificationTable.vue"
export default component.exports